import { getCurrentYear } from 'site-modules/shared/utils/time-util';

const TCO_DATA_YEARS_AVAILABLE = 5;

export function hasTcoDataByYear(year) {
  return parseInt(year, 10) >= getCurrentYear() - TCO_DATA_YEARS_AVAILABLE;
}
